module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-bar"
  }, [_c('div', {
    staticClass: "toggle-menu",
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('figure', [_c('figcaption', [_vm._v("SOU")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://urcamp.edu.br/site/img/logos/logo-branco.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-data"
  }, [_c('header-notificacoes'), _vm._v(" "), _c('div', {
    staticClass: "navegation"
  }, [_c('nav', {
    staticClass: "menu-icons"
  }, [(!!_vm.isMobile().any()) ? _c('div', {
    staticClass: "item-icon",
    attrs: {
      "title": "Acesso às Catracas"
    },
    on: {
      "click": _vm.gerarQRCodeCatracas
    }
  }, [_c('i', {
    staticClass: "fas fa-ticket-alt"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.primeiroNome))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.currentUser.ref_pessoa))])])]), _vm._v(" "), _c('div', {
    staticClass: "dropmenu-header"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "open-on-hover": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [(!_vm.avatar) ? _c('div', {
    key: "headerAvatarSigla",
    staticClass: "item-icon user",
    attrs: {
      "title": _vm.currentUser.pessoa.nome
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.currentUser.sigla) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.avatar) ? _c('div', {
    key: "headerAvatarImagem",
    staticClass: "user-avatar",
    style: ({
      backgroundImage: 'url(' + _vm.avatar + ')'
    }),
    attrs: {
      "title": _vm.currentUser.pessoa.nome
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": _vm.irParaMinhaConta
    }
  }, [_c('v-list-tile-title', [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Minha Conta")])])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-title', [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Sair")])])], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": true
    },
    model: {
      value: (_vm.mostrarModalQRCode),
      callback: function($$v) {
        _vm.mostrarModalQRCode = $$v
      },
      expression: "mostrarModalQRCode"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "qrcode-box",
    on: {
      "click": function($event) {
        _vm.mostrarModalQRCode = !_vm.mostrarModalQRCode
      }
    }
  }, [_c('div', {
    staticClass: "qrcode-message"
  }, [_vm._v("\n                    Coloque o brilho da tela do seu celular no máximo e aponte a tela para o leitor da catraca\n                ")]), _vm._v(" "), _c('div', [(false) ? _c('canvas', {
    ref: "qrcode",
    attrs: {
      "id": "qrcode"
    }
  }) : _vm._e(), _vm._v(" "), _c('canvas', {
    ref: "barcode",
    attrs: {
      "id": "barcode"
    }
  })])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-709ac612!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/Header.vue
// module id = 560
// module chunks = 2